import styled from "styled-components";

export const Container = styled.a`
  width: 25rem;
  height: 14%;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 1rem;
  margin: 2rem;
  padding: 2rem;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.1);
    filter: invert(100%);
    height: 65%;
  }

  #h1Title {
    font-size: 2.5rem;
  }

  #icon {
    width: 2.5rem;
    opacity: 0.85;
  }

  #preview {
    width: 100%;
    margin: 0.5rem;
    height: 100%;
    object-fit: cover;
    filter: invert(100%);
    border-radius: 1rem;
  }
`;
